export default __webpack_public_path__ + "99378daed7ca6713bed8fe37731f832c.png";